module.exports = __webpack_public_path__ + "static/media/herdy-standing-arm.fae5023d.svg";